
import React from 'react';

export const LocationSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            대상지 안내
          </h2>
          <p className="text-lg text-gray-600">
            강남 일원동 중심생활권과 인접한 개발지 파급효과
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* 지도 영역 */}
          <div className="relative">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="relative h-96">
                <img
                  src="https://static.readdy.ai/image/4a2a6b477d2273a3d0d5c5a7079aba9a/ea46c14190fa7ee090564077af857d55.jpeg"
                  alt="주민제안 구역계"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 bg-white rounded-lg px-3 py-2 shadow-md">
                  <p className="text-sm font-semibold text-gray-900">주민제안 구역계</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* 정보 영역 */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">구역 정보</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-map-pin-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">1구역</p>
                    <p className="text-gray-600">면적: 15,659㎡</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-map-pin-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">2구역</p>
                    <p className="text-gray-600">면적: 36,216㎡</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-map-pin-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">3구역</p>
                    <p className="text-gray-600">면적: 35,697㎡</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                    <i className="ri-building-line text-green-500"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">총 면적</p>
                    <p className="text-gray-600">87,572㎡ (약 26,485평)</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">구역별 특징</h3>
              <div className="grid grid-cols-1 gap-4">
                <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-yellow-400">
                  <div className="flex items-center mb-2">
                    <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center mr-2">
                      <span className="text-xs font-bold text-yellow-600">1</span>
                    </div>
                    <p className="text-sm font-semibold text-gray-900">1구역</p>
                  </div>
                  <p className="text-xs text-gray-600">소규모 주거지역, 기존 마을과 연계</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-green-400">
                  <div className="flex items-center mb-2">
                    <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-2">
                      <span className="text-xs font-bold text-green-600">2</span>
                    </div>
                    <p className="text-sm font-semibold text-gray-900">2구역</p>
                  </div>
                  <p className="text-xs text-gray-600">중심 개발구역, 주요 상업시설 계획</p>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-blue-400">
                  <div className="flex items-center mb-2">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                      <span className="text-xs font-bold text-blue-600">3</span>
                    </div>
                    <p className="text-sm font-semibold text-gray-900">3구역</p>
                  </div>
                  <p className="text-xs text-gray-600">복합개발구역, 주거 및 상업 혼재</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
